import type { MutableRefObject } from 'react';
import * as React from 'react';

import type { FullscreenDialogProps } from '@coursera/cds-core';
import { FullscreenDialog as CDSFullscreenDialog } from '@coursera/cds-core';

import type { TrackingProps } from './BaseComponent';
import useVisibilityTracker from './useVisibilityTracker';

type OwnProps = Omit<TrackingProps<'view_modal'>, 'trackingOptions'>;

type Props = OwnProps & Omit<FullscreenDialogProps, keyof OwnProps>;

/**
 * FullscreenDialog is a wrapper around CDS FullscreenDialog that tracks view modal events.
 */
const FullscreenDialog = ({ trackingData, ...props }: Props) => {
  const ref: MutableRefObject<HTMLDivElement | null> = useVisibilityTracker('view_modal', trackingData);

  return <CDSFullscreenDialog {...props} ref={ref} />;
};

FullscreenDialog.Header = CDSFullscreenDialog.Header;
FullscreenDialog.HeadingGroup = CDSFullscreenDialog.HeadingGroup;
FullscreenDialog.Actions = CDSFullscreenDialog.Actions;
FullscreenDialog.Content = CDSFullscreenDialog.Content;

export type { Props };

export default FullscreenDialog;
